export function getDiffFromNow(value: string) {
  const providedDate = new Date(value);
  const currentDate = new Date();
  const diffInMilliseconds = currentDate.getTime() - providedDate.getTime();

  const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
  const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
  const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));

  return {
    min: diffInMinutes,
    sec: diffInSeconds,
    hours: diffInHours,
  };
}

export function isOpenBeforeCloseTime(startTime: string, endTime: string) {
  const today = new Date().toISOString().split('T')[0];
  const start = new Date(`${today}T${startTime}:00`);
  const end = new Date(`${today}T${endTime}:00`);

  return start < end;
}
